import { Link, useRouteError } from 'react-router';
import { Logo } from '../shared/ui/components';

/** Pantalla amable cuando algo falla al mostrar una ruta (sin detalles técnicos). */
export function RouteError() {
  const error = useRouteError();
  if (import.meta.env.DEV) console.error(error);
  return (
    <main className="auth">
      <Logo />
      <div className="auth__panel">
        <h1>Algo salió mal</h1>
        <p className="muted">No pudimos mostrar esta pantalla. Intenta de nuevo en unos segundos.</p>
        <Link className="btn btn--primary" to="/app" reloadDocument>
          Volver al inicio
        </Link>
      </div>
    </main>
  );
}
